<template>
    <div class="modal-backdrop" v-if="visible">
        <div class="modal-content p-4 bg-white rounded shadow-lg position-relative">
            <button class="btn-close position-absolute top-0 end-0 m-2" @click="close"></button>
            <h5 class="fw-bold text-center">Your Number</h5>

            <!-- Number Tabs -->
            <div class="d-flex justify-content-center my-2 flex-wrap">
                <div v-for="(digit, index) in selectedNumbers" :key="index" class="circle mx-1"
                    :class="index === 0 ? 'active' : ''">
                    {{ digit }}
                </div>
            </div>

            <p class="text-center text-muted mb-3">Europe Lotto matched result for the past 30 days</p>

            <!-- Scrollable Table -->
            <div class="table-scrollable">
                <table class="table table-bordered text-center">
                    <thead class="table-light">
                        <tr>
                            <th>Day</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in results" :key="index">
                            <td>{{ row.day }}</td>
                            <td>{{ row.date }}</td>
                            <td>{{ row.time }}</td>
                            <td>
                                <span v-for="(digit, dIndex) in row.result.split('')" :key="dIndex"
                                    class="digit-circle mx-1" :class="{ highlight: selectedNumbers.includes(digit) }">
                                    {{ digit }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        visible: Boolean,
        selectedNumbers: Array,
        results: Array, // each row now has one 'result' key only
    },
    methods: {
        close() {
            this.$emit("close");
        },
        formatNumber(num) {
            return num?.split("")?.join(" ") || "";
        },
    },
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow-y: auto;
}

.modal-content {
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
}

.circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-bottom: 5px;
}

.circle.active {
    background-color: #007bff;
    color: white;
}

.table-scrollable {
    max-height: 400px;
    overflow-y: auto;
}

.digit-circle {
    display: inline-flex;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #fff;
    border: 2px solid #000;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.digit-circle.highlight {
    background-color: yellow;
    border-color: #000;
}
</style>
